import './About.scss';

function About() {
  return(
    <section className="About" id='About'>
      <div className="About-detail">
        <h4 className="About-detail-title">ABOUT ME</h4>
        <div className="About-detail-wrapper">
          <div className='About-detail-wrapper-image'>
            <img src="https://source.unsplash.com/m_HRfLhgABo" alt="macbook with code on the screen" />
          </div>
          <h3 className="About-detail-wrapper-header">From Dreams to Code: Creating Web Wonders</h3>
          <p className='About-detail-wrapper-text'>
            With a recent graduation from an intensive web development course that earned me a Bac +2 degree, I've laid a solid foundation for my journey into the digital realm. 
            Eager to delve even deeper, I'm currently pursuing a bachelor's degree in a 'Project Web and Mobile' program at Bac +3 level. 
            This academic pusuit goes hand in hand with real-world exposure through an internship contract, allowing me to seamlessly bridge theory and practice. 
            Join me as I weave code into captivating web and mobile experiences, drawing inspiration from the vibrant culture and innovation that Paris ignites within me.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
